export * from './color-code.enum';